import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {create_UUID, filterTransactionTypes, getLabelByValue, RightExists, showAxiosError} from "../../util/Helpers";
import PaymentForm from "./PaymentForm";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import moment from "moment";
import LoadingIndicator from "../../common/LoadingIndicator";
import * as headerContent from "../../constants/exportcontent";
import Alert from "react-s-alert";
import {Button, Dropdown, Menu} from "antd";
import Icon from "antd/es/icon";
import TransactionTypeDeleteModal from "./TransactionTypeDeleteModal";
import PaymentDeleteModal from "./PaymentDeleteModal";


class PaymentList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            add: false,
            addDeleteModal:false,
            selectedPayment: null,
            branches: null,
            payments: [],
            totalIdList: [],
            expenseTypes: [],
            transactionChannels: [],
            transactionTypes: [],
            cities: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addPaymentModal: false,
            isLoading: false,
        };

        this.listPayments = this.listPayments.bind(this);
        this.cancelPaymentCreation = this.cancelPaymentCreation.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.listPaymentTypes = this.listPaymentTypes.bind(this);
        this.listTransactionChannels = this.listTransactionChannels.bind(this);
    }

    componentDidMount() {
        this.listPaymentTypes();
        this.listTransactionChannels();
        this.listPayments();
    }

    listPaymentTypes() {
        let self = this;
        let params = {
            //url: API_BASE_URL+"/transaction-type/expenses" ,
            url: API_BASE_URL + "/transaction-type/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionTypes = response.data;
                self.setState({
                    transactionTypes,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listTransactionChannels() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-channel/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionChannels = response.data;
                self.setState({
                    transactionChannels,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    addNew() {
        let self = this;
        self.setState({
            selectedPayment: null,
            addPaymentModal: true,
            add:true,
        })
    }

    arrangeDataSet() {
        let dataSet = {};
        dataSet.headers = headerContent.expenseContent;
        dataSet.sheetName = 'Gider İşlemleri Listesi';
        dataSet.uuid = create_UUID();
        dataSet.idList = this.state.totalIdList;
        return dataSet;
    }

    async exportXls() {
        let self = this;
        let data = self.arrangeDataSet();
        let params = {
            url: API_BASE_URL + '/financial-transaction/downloadReportExpenses', //TODO: self
            method: "post",
            data: data,
        };
        Alert.success(
            "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'İNDİRME TALEPLERİNİZ'" +
            " butonuna tıklayarak excel dosyasını indirebilirsiniz.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 10000
            });
        await request(params).then(() => {
            self.props.triggerDownloadRequestTooltip();
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listPayments(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/financial-transaction/fetchExpenses?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let payments = (response.data && response.data.page) ? response.data.page.content : [];
                let totalIdList = response.data ? response.data.selectedIdList : [];
                let totalChanged = false;
                if (response.data.page.totalElements !== self.state.total) {
                    totalChanged = true;
                }

                self.setState({
                    page: !totalChanged ? page : 0,
                    size: size,
                    total: response.data.page.totalElements,
                    payments,
                    totalIdList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    cancelPaymentCreation() {
        this.setState({
            addPaymentModal: false,
            selectedPayment: null,
            addDeleteModal: false,
        });
        this.listPayments(this.state.accessor, this.state.direction, this.state.page, this.state.size);
    }

    handleEdit(item) {
        let self = this;
        let data = item.id;
        let params = {
            url: API_BASE_URL + "/financial-transaction/" + item.id,
            data: data,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                mode: 'edit',
                selectedPayment: response.data,
                addPaymentModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listPayments(this.state.accessor, this.state.direction, page, this.state.size))
    }

    handleDelete(item) {
        this.setState({
            selectedPayment: item,
            addDeleteModal: true
        })
    }

    render() {
        let expenseTypeSelectdata;
        let transactionChannelSelectdata;
        let transactionTypes;
        let transactionChannels;
        let branchSelectdata;

        const {payments} = this.state;
        const {branches} = this.props;
        const header = [{value: null, label: "Tümü"}];
        const branchHeader = [{value: null, label: "Tümü"}, {value: "0", label: "BİRLİK MERKEZİ"},];
        const isCancelledSelectData = [{value: null, label: "Tümü"}, {
            value: "true",
            label: "İptal Edildi"
        }, {value: "false", label: "Aktif"}]


        transactionTypes = this.state.transactionTypes;
        transactionChannels = this.state.transactionChannels;
        branches ? branchSelectdata = branchHeader.concat(branches) : branchSelectdata = branchHeader;
        let expenseTypes = transactionTypes ? filterTransactionTypes(transactionTypes, "EXPENSE") : [];
        expenseTypes ? expenseTypeSelectdata = header.concat(expenseTypes) : expenseTypeSelectdata = header;
        transactionChannels ? transactionChannelSelectdata = header.concat(transactionChannels) : transactionChannelSelectdata = header;

        const menu = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit(this.state.selectedItem)}>
                    Gider Düzenle
                </Menu.Item>
                <Menu.Item onClick={() => this.handleDelete(this.state.selectedItem)}>
                    Gider Silme
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                Header: "Kişi/Şirket Adı",
                accessor: "transactionTitle",
            },
            {
                Header: "Gider Durumu ",
                accessor: "isCanceled",
                Cell: (item) => {
                    if (item.isCancelled)
                        return <label style={{color: 'red'}}>İptal Edildi</label>;
                    else
                        return <label>Aktif</label>;
                },
            },
            {
                Header: "İşlem Tarihi",
                accessor: "transactionDate",
                Cell: item => (
                    <label>{moment.utc(item.transactionDate).format("DD.MM.YYYY")}</label>
                )
            },
            /*{
                Header: "Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.branchId && branchSelectdata[item.branchId].label.toString().substring(0,20)+"..." }</label>
                )
            },*/
            /* {
                 Header: "Gider Tipi",
                 accessor: "transactionTypeId",
                 Cell: item => (
                     <label>{(transactionTypes.length>0&&item.transactionTypeId) ? transactionTypes[item.transactionTypeId-1].name.toString().length>20?transactionTypes[item.transactionTypeId-1].name.toString().substring(0,17)+'...':transactionTypes[item.transactionTypeId-1].name.toString() : ''}</label>)
             },
             {
                 Header: "İşlem Kanalı",
                 accessor: "transactionChannelId",
                 Cell: item => (
                 <label>{(item.transactionChannelId&&transactionChannels.length>0) ? transactionChannels[item.transactionChannelId-1].label : ''}</label>)
             },*/
            {
                Header: "Tutar",
                accessor: "amount",
                Cell: item => (
                    <label>{item.amount && item.amount.toString().replace('.', ',') + ' ₺'}</label>)
            },

        ];

        if (this.props.currentUser.realm.toString() === "0") {
            columns.push({
                Header: "Oda",
                accessor: "branchId",
                Cell: item => (
                    <label>{branchSelectdata && getLabelByValue(branchSelectdata, item.branchId).toString().substring(0, 15) + ".."}</label>
                )
            });
        }

        columns.push({
            Header: "İşlemler",
            accessor: "",
            sortable: false,
            Cell: item => (
                <div>
                    <Dropdown overlay={menu}
                              trigger='click'
                              onClick={() => this.setState({selectedItem: item})}
                    >
                        <Button style={{
                            background: '#3b6b96',
                            height: '30px',
                            width: '100px',
                            color: 'white',
                            borderRadius: '0.375em',
                            fontSize: "12px",
                        }}>
                            Seçiniz<Icon type="down"/>
                        </Button>
                    </Dropdown>
                </div>

                // <div>
                //     <button type="button"
                //             onClick={() => this.handleEdit(item)}
                //             data-toggle="tooltip" data-placement="bottom" title="Düzenle"
                //             style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                //             rel="tooltip" className="Btn btn-sm btn-icon">
                //         <i className="fa fa-edit"/>
                //     </button>
                // </div>
            )
        });
        const fields = [
            {
                accessor: "transactionTitle",
                label: "Kişi/Şirket Adı",
                type: "text",
                operator: "=",
            },
            {
                label: "Gider Tipi",
                accessor: "transactionTypeId",
                type: "select",
                operator: "=",
                selectData: expenseTypeSelectdata,
            },
            {
                label: "İşlem Tarihi(..'den Sonra)",
                accessor: "min_transactionDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "İşlem Tarihi(..'den Önce)",
                accessor: "max_transactionDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: "<=",
            },
            {
                label: "İşlem Kanalı",
                accessor: "transactionChannelId",
                type: "select",
                operator: "=",
                selectData: transactionChannelSelectdata,
            },
            {
                label: "Gider Durumu",
                accessor: "isCancelled",
                type: "select",
                operator: "=",
                selectData: isCancelledSelectData,
            },
        ];
        if (this.props.currentUser.realm.toString() === "0") {
            fields.push({
                label: "Oda",
                accessor: "branchId",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },);
        }

        return (
                <div className="row baseBackground">
                    {
                        (this.state.isLoading) &&
                        <div className="loader">
                            <LoadingIndicator/>
                        </div>
                    }
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">Oda Gider Listesi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={payments}
                                total={this.state.total}
                                page={this.state.page}
                                manual={this.state.manual}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                columns={columns}
                                fetchData={this.listPayments}
                                style={{width:"100%"}}
                            />
                        </div>

                    {
                        (RightExists("ROLE_RIGHT_PAYMENT_CREATE", this.props.authorities))
                        &&
                        <div className="new-button-holder">
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Yeni Gider Ekle"
                                    style={{
                                        background: 'linear-gradient(#2b93cd, #0a66b7)',
                                        height: '40px',
                                        width: '160px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                        marginBottom:"5px",
                                    }}
                                    rel="tooltip"
                                    className="TekBtn add-new-financial "
                                    onClick={() => this.addNew()}>
                                YENİ GİDER EKLE
                            </button>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Excel İndir"
                                    style={{
                                        background: 'linear-gradient(#129a30, #116128)',
                                        height: '40px',
                                        width: '160px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                    }}
                                    rel="tooltip" className="TekBtn excel "

                                    onClick={() => this.exportXls()}>
                                GİDER EXCEL İNDİR
                            </button>
                        </div>
                    }
                    </div>
                    <Modal isOpen={this.state.addPaymentModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelPaymentCreation}>
                            {this.state.add
                                ?
                                'Yeni Gider Ekleme'
                                :
                                'Gider Düzenleme'
                            }
                        </ModalHeader>
                        <ModalBody>
                            <PaymentForm cancelProcess={this.cancelPaymentCreation}
                                         selectedPayment={this.state.selectedPayment}
                                         mode={this.state.mode}
                                         currentUser={this.props.currentUser}
                                         handleSearch={this.handleSearch}
                                         transactionTypes={this.state.transactionTypes}
                                         transactionChannels={this.state.transactionChannels}
                            />
                        </ModalBody>
                    </Modal>
                    <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelPaymentCreation}>
                            Gider Silme
                        </ModalHeader>
                        <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                            <PaymentDeleteModal
                                cancelProcess={this.cancelPaymentCreation}
                                selectedPayment={this.state.selectedPayment}
                                handleLogout={this.handleLogout}/>
                        </ModalBody>
                    </Modal>
                </div>
        )
    }
}

export default PaymentList;



// WEBPACK FOOTER //
// ./src/page/financial/PaymentList.js